import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';

export const createBooleanLiteral = (value: boolean) => ({
  type: NodeType.BooleanLiteral,
  loc,
  value,
  original: value,
});
